export default "__VITE_ASSET__DBq5aWxg__"